<script>
import feather from 'feather-icons'
import HeroCarousel from './HeroCarousel.vue'

export default {
  name: 'Home',
  components: {
    HeroCarousel,
  },
  data: () => {
    return {
      theme: '',
    }
  },
  created() {
    this.theme = 'dark'
  },
  mounted() {
    feather.replace()
    this.theme = 'dark'
  },
  updated() {
    feather.replace()
  },
  methods: {},
}
</script>

<template>
  <section
    class="w-full flex flex-col-reverse lg:flex-row items-center justify-between gap-12 lg:gap-20 py-16"
  >
    <!-- Left Content -->
    <div class="w-full lg:w-5/12 text-center lg:text-left">
      <span
        class="font-display inline-block text-brand-500 tracking-[0.3em] uppercase text-sm mb-4"
      >
        // Vehicle &amp; Wall Wraps/Wall Graphic Installation
      </span>

      <h1
        class="font-display font-bold text-5xl xl:text-6xl uppercase leading-none text-primary-light"
      >
        Visual Impact. 
        <span class="text-brand-500">Perfect Execution.</span>
      </h1>

      <p
        class="mt-6 font-general-medium text-lg xl:text-2xl leading-relaxed text-ternary-light"
      >
        Turn your biggest assets into non-stop marketing tools. Expertly
        installing high-quality vehicle wraps and commercial graphics that
        demand attention everywhere your business operates.
      </p>

      <!-- Service tags -->
      <div class="mt-8 flex flex-wrap justify-center lg:justify-start gap-3">
        <router-link
          v-for="category in ['Racecar', 'Commercial', 'Flat']"
          :key="category"
          :to="{ path: '/projects', query: { category } }"
          class="font-display uppercase tracking-wide text-sm px-4 py-2 clip-corner-sm bg-secondary-dark text-primary-light border border-ternary-dark hover:border-brand-500 hover:text-brand-500 duration-300"
          >{{ category }}</router-link
        >
      </div>

      <div class="mt-10 flex justify-center lg:justify-start">
        <router-link
          to="/contact"
          class="font-display uppercase tracking-wider font-semibold clip-corner px-6 py-3 shadow-glow hover:shadow-glow-lg bg-brand-600 hover:bg-brand-700 text-white text-lg duration-300"
          aria-label="Contact Us"
        >
          Contact Us
        </router-link>
      </div>
    </div>

    <!-- Right Image Carousel -->
    <div class="w-full lg:w-7/12 flex justify-center lg:justify-end">
      <HeroCarousel />
    </div>
  </section>
</template>

<style scoped></style>
